export default {
  locale: 'en',
  messages: {
      administrationTitle: 'Administration',

      alertUnauthorized: 'Your session expired! Please login to your account.',

      cartStepPaymentTitle: 'Your payment',
      cartStepPaymentInfoText: 'Congratulations, we\'re almost done!<br />Select your payment method.',
      cartStepPreviewTitle: 'Your cart',
      cartStepPreviewInfoText: 'You are in your cart.<br />Think about our decreasing prices.',
      cartStepShippingTitle: 'Your details',
      cartStepShippingInfoText: 'Check your shipping address with all the necessary information<br /> for the carrier for good delivery.',

      dashboardTitle: 'Dashboard',

      langDE: 'Deutsh',
      langEN: 'English',
      langES: 'Español',
      langFR: 'Français',

      productUnitCountLabel: `{count} {count, plural,
          =0 {bottle}
          =1 {bottle}
          other {bottles}
      }`,

      users: 'Users',
  },
};
